<template>
    <div ref="container">
      <a-modal :title="title" :width="1300" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height:60%;">
        <a-card style="margin-bottom:30px">
          <a-descriptions title="PI注册信息">
            <a-descriptions-item label="产品DI">{{ productInfo.productDi }}</a-descriptions-item>
            <a-descriptions-item label="产品名称">{{ productInfo.productName }}</a-descriptions-item>
            <a-descriptions-item label="序列号长度">{{ productInfo.serialLength }}</a-descriptions-item>
            <a-descriptions-item label="序列号前缀">{{ productInfo.serialPrefix }}</a-descriptions-item>
            <a-descriptions-item label="序列号起始号">{{ productInfo.serialStartNum }}</a-descriptions-item>
            <a-descriptions-item label="序列号终止号">{{ productInfo.serialEndNum }}</a-descriptions-item>
            <a-descriptions-item label="生产日期" v-if="productInfo.startDate">{{ changeDate(productInfo.startDate)
            }}</a-descriptions-item>
            <a-descriptions-item label="生产批号">{{ productInfo.batchNumber }}</a-descriptions-item>
            <a-descriptions-item label="有效期">{{ productInfo.effectiveDate }}</a-descriptions-item>
            <a-descriptions-item label="失效期" v-if="productInfo.endDate">{{
              changeDate(productInfo.endDate) }}</a-descriptions-item>
            <a-descriptions-item label="灭菌批号">{{ productInfo.dBatchNumber }}</a-descriptions-item>
          </a-descriptions>
        </a-card>
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品UDI-PI编码">
                  <a-input placeholder="请输入产品UDI-PI编码" v-model="search"></a-input>
                </a-form-item>
              </a-col>
              <span style="float:left;overflow:hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <!-- <a-button style="margin-left: 8px" @click="allPrint">打印</a-button> -->
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <a-table ref="table" :dataSource="dataSource" :rowKey="(record, index) => { return index }"
                 :pagination="ipagination" :loading="loading" :columns="columns" @change="handleTableChange"
                 :components="handleDrag(columns)"
                 :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'30px'}" >
          <span slot="action" slot-scope="text, record">
            <a @click="myHandleDetailPI(record)">打印</a>
          </span>
          <span slot="packageSpec" slot-scope="text, record">
            <span>初级包装:{{ record.packageSpecification }}</span>
          </span>
          <span slot="startDate" slot-scope="text, record">
            <span v-if="record.startDate">{{ changeDate(record.startDate) }}</span>
            <span v-else></span>
          </span>
          <span slot="endDate" slot-scope="text, record">
            <span v-if="record.endDate">{{ changeDate(record.endDate) }}</span>
            <span v-else></span>
          </span>
        </a-table>
      </a-modal>
    </div>
  </template>
  <script>
  import { getpiSecurityInfo } from '@/api/api'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import startPrint from '@/views/UDIadmin/modules/allPrint'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin],
    components: {

    },
    data() {
      return {
        title: 'PI列表',
        visible: false,
        model: {},
        dataSource: [],
        loading: false,
        productInfo: {},
        search: '',
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0,
        },
        isorter: {
          column: 'createTime',
          order: 'desc',
        },
        columns: [
          {
            title: '产品UDI-PI编码',
            dataIndex: 'productDi',
            width: 150,
          },
          {
            title: '产品名称',
            dataIndex: 'productName',
          },
          {
            title: '品类编码',
            dataIndex: 'productNo',
          },
          {
            title: '包装规格',
            dataIndex: 'packageSpecification',
            scopedSlots: { customRender: 'packageSpec' },
          },
          {
            title: '生产日期',
            dataIndex: 'startDate',
            scopedSlots: { customRender: 'startDate' },
          },
          {
            title: '生产批号',
            dataIndex: 'batchNumber',
          },
          {
            title: '灭菌批号',
            dataIndex: 'dBatchNumber',
          },
          {
            title: '失效日期',
            dataIndex: 'endDate',
            scopedSlots: { customRender: 'endDate' },
          },
          {
            title: '序列号',
            dataIndex: 'serialNumber',
          },
          {
            title: '防伪码',
            dataIndex: 'piSecurityCode',
          },
        //   {
        //     title: '操作',
        //     dataIndex: 'action',
        //     align: 'center',
        //     width: 180,
        //     scopedSlots: { customRender: 'action' },
        //   },
        ],
      }
    },
    created() {
    },
    // mounted(){
    //     this.getlist()
    // },
    methods: {
      //判断
      searchQuery() {
        this.getlist()
      },
      searchReset() {
        this.search = ''
        this.getlist()
      },
      changeDate(Date) {
        return Date.substring(0, 10)
      },


      async getlist(e) {
        this.visible = true
        this.loading = true
        this.productInfo.productDi = e.productDi
        this.productInfo.productName = e.productName
        this.productInfo.serialLength = e.serialLength
        this.productInfo.serialPrefix = e.serialPrefix
        this.productInfo.serialStartNum = e.serialStartNum
        this.productInfo.serialEndNum = e.serialEndNum
        this.productInfo.startDate = e.startDate
        this.productInfo.batchNumber = e.batchNumber
        this.productInfo.effectiveDate = e.effectiveDate
        this.productInfo.endDate = e.endDate
        this.productInfo.dBatchNumber = e.dBatchNumber
        let params = {
          id: e.id,
          page: 1,
          limit: 10,
        }
        const res = await getpiSecurityInfo(params)
        if (res.errno == 200 && res.errmsg == '成功') {
          this.loading = false
          this.dataSource = res.data.list
          this.ipagination.total = res.data.total
        //   this.productInfo = {
        //     productDi:
        //   }
        } else {
          this.$message.error(res.data || res.errmsg)
          this.dataSource = []
          this.loading = false
        }
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field
          this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
        }
        if (pagination && pagination.current) {
          this.ipagination = pagination
        }
        this.getlist()
      },
      async myHandleDetailPI(record) {
        // this.$refs.SelectModelref.add(record)
        let type = 'Singleprinting'
        this.$refs.allSelectModelRef.addStr(record, type)
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      initShow(e){
          console.log(e,'======================e===============')
          this.visible = true
      },
      handleOk() {
        // 触发表单验证
        this.handleCancel()
      },
      handleCancel() {
        this.close()
      },
    },
  }
  </script>
  <style scoped></style>